import { queryOptions } from '@tanstack/react-query';
import {
    ConnectedAccount,
    Notification,
    RoleResolved,
    UserResolved,
    UsersResponse,
} from '../../types/users';
import { ApiError } from '~/components/Providers/APIClient';
import { apiQueryFn } from '../utils';
import { usersParamsType } from '~/routes/_authenticated/staff/users/-SearchParams';

export const usersQuery = ({
    page,
    per_page,
    name_filter,
    placeholder_filter,
    ban_level_filter,
}: usersParamsType = {}) =>
    queryOptions<UsersResponse, ApiError>({
        queryKey: [
            'users',
            page,
            per_page,
            name_filter,
            placeholder_filter,
            ban_level_filter,
        ],
        queryFn: apiQueryFn<UsersResponse>({
            path: `/users`,
            query: {
                page: page,
                per_page: per_page,
                name_filter: `%${name_filter ?? ''}%`,
                placeholder: placeholder_filter,
                ban_level: ban_level_filter,
            },
            attachAuth: true,
        }),
    });

export const userQuery = ({ userid }: { userid: string }) =>
    queryOptions<UserResolved, ApiError>({
        queryKey: ['users', userid],
        queryFn: apiQueryFn<UserResolved>({
            path: `/users/${userid}`,
            attachAuth: true,
        }),
    });

export type userMeQueryParams = {
    token?: string;
};

export const userMeQuery = ({ token }: userMeQueryParams = {}) =>
    queryOptions<UserResolved, ApiError>({
        queryKey: ['users', '@me'],
        queryFn: apiQueryFn<UserResolved>({
            path: `/users/@me`,
            attachAuth: true,
            token,
        }),
    });

export const namesQuery = () =>
    queryOptions<RoleResolved[], ApiError>({
        queryKey: ['editors'],
        queryFn: apiQueryFn<RoleResolved[]>({ path: '/users/names' }),
    });

export const userNotificationsQuery = () =>
    queryOptions<Notification[], ApiError>({
        queryKey: ['users', '@me', 'notifications'],
        queryFn: apiQueryFn<Notification[]>({
            path: `/users/@me/notifications`,
            attachAuth: true,
        }),
    });

export const rolesQuery = () =>
    queryOptions<RoleResolved[], ApiError>({
        queryKey: ['roles'],
        queryFn: apiQueryFn<RoleResolved[]>({
            path: `/roles`,
            attachAuth: true,
        }),
    });

export const userConnectedAccountsQuery = ({ user_id }: { user_id: string }) =>
    queryOptions<ConnectedAccount[], ApiError>({
        queryKey: ['connected_accounts', user_id, 'connected_accounts'],
        queryFn: apiQueryFn<ConnectedAccount[]>({
            path: `/auth/connected-accounts/user/${user_id}`,
            attachAuth: true,
        }),
    });
